import React, { useState } from 'react'
import { connect } from 'react-redux'
import { authVerifyPasswordRequest } from '../../../../../action/auth-actions'
import { collapseRightToolbar } from '../../../../../action/right-toolbar-state-actions'
import { userUpdateRequest } from '../../../../../action/user-actions'
import { collapseLeftToolbar } from '../../../../../action/left-toolbar-state-actions'

const Password = props => {
  const { authVerifyPasswordRequest } = props,
    [currentIsValid, setCurrentValid] = useState(false),
    [currentError, setCurrentError] = useState(null),
    [newPW, setNewPW] = useState(null),
    [newPWError, setNewPWError] = useState(null),
    [newConfirmError, setConfirmError] = useState(null),
    [newIsValid, setNewIsValid] = useState(false),
    [loading, setLoading] = useState(false),
    [pwSaved, setPWSaved] = useState(false),
    [currentPassword, setCurrentPassword] = useState(''),
    [newPassword, setNewPassword] = useState(''),
    [reenterPassword, setReenterPassword] = useState(''),
    [error, setNoerror] = useState(false),

    validateCurrent = e => {
      const { value } = e.target,
        { user } = props,
        { email } = user
      authVerifyPasswordRequest({ email, password: value })
        .then(res => {
          setCurrentValid(true)
          setNewPWError('')
        })
        .catch(err => {
          setCurrentValid(false)
          currentPassword.length > 2 && setNewPWError('The current password is not correct')
        })
    },


    onBlurValidate = (e) => {
      const confirm = e.target.value

      if (newPassword.length < 8 && newPassword.length > 1) {
        setNewPWError('Password must be at least 8 characters long');
        return
      } else {
        if (newPassword === currentPassword) {
          setNewPWError('The new password and old psd you entered do not match');
        } else if (newPassword != reenterPassword) {
          if (newPassword.length < 7) {
            setNewPWError('New password must be 8 characters or longer')
          } else {
            if (reenterPassword.length > 2)
              setNewPWError('The new passwords you entered do not match');
          }

          return
        } else {
          setNoerror(true)
        }
      }
    },


    saveNewPW = e => {
      if (currentIsValid) {
        const { email, firstName, lastName } = props.user
        if (newPassword === reenterPassword && newPassword != currentPassword) {
          setLoading(true)
          props.userUpdateRequest({
            email,
            firstName,
            lastName,
            password: newPassword,
            enabled: true
          })
            .then(() => {
              setPWSaved(true)
            })
        } else {
          if (newPassword === currentPassword) {
            setNewPWError('New Password and Cuurnet Password not same')
          } else {
            // alert('psd and rpsd not same')
            if (newPassword.length < 7) {
              setNewPWError('New password must be 8 characters or longer')
            }
            else {
              if (reenterPassword.length > 2) {
                setNewPWError('The new passwords you entered do not match')
              }
            }

          }
        }
      }
    }
  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      {/* <h2 style={{ textAlign: 'center', padding: '10px', marginTop: 20 }}>Edit Password</h2> */}
      <div className='left-expanded-header-container'>
        <div className='default-back left-dialog-close'
          onClick={props.fromLeftBar ? props.cancelEdit : props.collapseRightToolbar}></div>
        <span className='left-expanded-header'>Edit Password</span>
      </div>
      <div className='right-toolbar-profile-input-container'
        style={{ width: '92%', boxSizing: 'border-box', margin: '5px' }}>
        <label htmlFor='current-password'
          style={{
            fontSize: '12px'
          }}>Current Password</label>
        <input type='password'
          className='left-toolbar-profile-input'
          name='current-password'
          id='current-password'
          placeholder='Current Password'
          onChange={(e) => {
            if (currentError) {
              setCurrentError(null)
            }
            setCurrentPassword(e.target.value)
          }}
          onBlur={(e) => {
            validateCurrent(e)
          }}
        ></input>
      </div>
      <div className='right-toolbar-profile-input-container'
        style={{ width: '92%', boxSizing: 'border-box', margin: '5px' }}>
        <label htmlFor='current-password'
          style={{
            fontSize: '12px'
          }}>New Password</label>
        <input type='password'
          className='left-toolbar-profile-input'
          name='new-password'
          id='new-password'
          placeholder='New Password'
          onChange={(e) => {
            if (newPWError) {
              setNewPWError(null)
            }
            if (newPassword.length > 7 && error) setNewPWError('')
            setNewPassword(e.target.value)
          }}
          onBlur={
            onBlurValidate
          }
        >
        </input>
      </div>
      <div className='right-toolbar-profile-input-container'
        style={{ width: '92%', boxSizing: 'border-box', margin: '5px' }}>
        <label htmlFor='current-password'
          style={{
            fontSize: '12px'
          }}>Re-Enter New Password</label>
        <input type='password'
          className='left-toolbar-profile-input'
          name='new-password-confirm'
          id='new-password-confirm'
          placeholder='Re-Enter New Password'
          onChange={(e) => {
            setReenterPassword(e.target.value)
            if (newPWError) {
              setConfirmError(null)
            }
            if (newPassword.length > 7 && error) setNewPWError('')
          }}
          onBlur={onBlurValidate}>
        </input>
        {
          newConfirmError ? (<p className='right-toolbar-profile-error'>
            {newConfirmError}</p>) : null
        }
      </div>
      <div style={{ display: 'flex', width: '95%' }}>
        <button style={{
          backgroundColor: 'gray',
          fontSize: 15
        }}
          onClick={
            props.fromLeftBar ? props.cancelEdit : props.collapseLeftToolbar
          }>Cancel</button>
        <button onClick={saveNewPW} style={{ fontSize: 15 }}>
          Save New Password
        </button>
      </div>
      {
        newPWError ? (<p className='right-toolbar-profile-error'>
          {newPWError}</p>) : null
      }

      {loading ? <div style={{ backgroundColor: 'rgba(0,0,0,0.7)', width: '100%', height: '100%', position: 'absolute', top: '0px', left: '0px' }}>
        {pwSaved ? <button className='center' style={{ width: '70%' }} onClick={props.collapseLeftToolbar}>Return To Map</button> : <div className='loading-spinner center'></div>}
      </div> : null}
    </div>
  )
}
const mapStateToProps = state => ({
  auth: state.auth,
  user: state.user
})

const mapDispatchToProps = dispatch => ({
  authVerifyPasswordRequest: obj => dispatch(authVerifyPasswordRequest(obj)),
  collapseRightToolbar: () => dispatch(collapseRightToolbar()),
  userUpdateRequest: obj => dispatch(userUpdateRequest(obj)),
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar())
})

export default connect(mapStateToProps, mapDispatchToProps)(Password)
